import * as React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  useSidebar,
} from "../ui/sidebarNew";
import {
  ChevronLeft,
  ChevronRight,
  Link,
  Rocket,
  Target,
  UserRoundPen,
} from "lucide-react";
import {
  LayoutDashboardIcon,
  StickyNote,
  Navigation,
  List,
  HandCoins,
  ShoppingCart,
  MessagesSquare,
  GalleryVerticalEnd,
  ChartNoAxesCombined,
  ThumbsUp,
  ScrollText,
  ShieldAlert,
  BookOpenCheck,
  ScreenShare,
  Megaphone,
} from "lucide-react";

export const BrandSidebar = ({ user, handleAnchorClick }) => {
  const navigate = useNavigate();
  const { state, toggleSidebar } = useSidebar();
  const isCollapsed = state === "collapsed";

  const handleLogoClick = () => {
    navigate("/brand/dashboard");
  };

  const SectionDivider = () => (
    <div className="my-3 border-t border-green-400/50"></div>
  );

  return (
    <Sidebar
      className={`${
        isCollapsed ? "!w-20" : "!w-64"
      } bg-green-50 z-[950] transition-all duration-300 border-r border-green-200 shadow-xl h-screen`}
      collapsible="icon"
    >
      <SidebarHeader className="border-b h-16 flex items-center justify-center bg-green-50 border-b-green-200 relative">
        <div
          className={`flex items-center w-full relative ${
            isCollapsed ? "justify-center" : "justify-between pr-4 pl-7"
          }`}
        >
          <div
            className="flex items-center gap-3 !cursor-pointer"
            onClick={handleLogoClick}
          >
            <div className="w-9 h-9 bg-gradient-to-br from-green-600 to-green-700 rounded-lg flex items-center justify-center">
              <img
                src={process.env.PUBLIC_URL + "/favicon/favicon.ico"}
                className="h-6 w-6"
                alt="Logo"
              />
            </div>
            {!isCollapsed && (
              <span className="font-semibold text-xl text-green-900">TAMA</span>
            )}
          </div>
          <button
            className="w-6 h-6 shadow-md rounded-full bg-green-800 border border-green-700 hover:bg-green-700 flex items-center justify-center absolute -right-3 top-1/2 transform -translate-y-1/2 hover:shadow-lg transition-all z-[100]"
            onClick={toggleSidebar}
          >
            {isCollapsed ? (
              <ChevronRight className="w-4 h-4 text-white" />
            ) : (
              <ChevronLeft className="w-4 h-4 text-white" />
            )}
          </button>
        </div>
      </SidebarHeader>

      <SidebarContent
        className={`${
          isCollapsed ? "px-2 py-4" : "px-4 py-4"
        } space-y-1 overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]`}
      >
        <nav className="space-y-1">
          <NavLink
            to="/brand/dashboard"
            onClick={handleAnchorClick}
            className={({ isActive }) =>
              `flex items-center w-full px-6 py-2.5 text-sm font-medium rounded-lg transition-all ${
                isActive
                  ? "bg-green-700 text-white shadow-md"
                  : "text-green-900 hover:bg-green-100"
              }`
            }
          >
            {!isCollapsed && (
              <LayoutDashboardIcon className="w-5 h-5 mr-3 flex-shrink-0" />
            )}
            {isCollapsed && (
              <LayoutDashboardIcon className="w-5 h-5 flex-shrink-0" />
            )}
            {!isCollapsed && <span className="truncate">Dashboard</span>}
          </NavLink>
          {/* <NavLink
            to="/brand/jobCampaigns"
            onClick={handleAnchorClick}
            className={({ isActive }) =>
              `flex items-center w-full px-6 py-2.5 text-sm font-medium rounded-lg transition-all ${
                isActive
                  ? "bg-green-700 text-white shadow-md"
                  : "text-green-900 hover:bg-green-100"
              }`
            }
          >
            {!isCollapsed && <Rocket className="w-5 h-5 mr-3 flex-shrink-0" />}
            {isCollapsed && <Rocket className="w-5 h-5 flex-shrink-0" />}
            {!isCollapsed && (
              <span className="truncate">Targeted Campaigns</span>
            )}
          </NavLink> */}
          <NavLink
            to="/brand/brandpage"
            onClick={handleAnchorClick}
            className={({ isActive }) =>
              `flex items-center w-full px-6 py-2.5 text-sm font-medium rounded-lg transition-all ${
                isActive
                  ? "bg-green-700 text-white shadow-md"
                  : "text-green-900 hover:bg-green-100"
              }`
            }
          >
            {!isCollapsed && (
              <UserRoundPen className="w-5 h-5 mr-3 flex-shrink-0" />
            )}
            {isCollapsed && <UserRoundPen className="w-5 h-5 flex-shrink-0" />}
            {!isCollapsed && <span className="truncate">Brand Profile</span>}
          </NavLink>

          <NavLink
            to="/brand/influencerdiscovery"
            onClick={handleAnchorClick}
            className={({ isActive }) =>
              `flex items-center w-full px-6 py-2.5 text-sm font-medium rounded-lg transition-all ${
                isActive
                  ? "bg-green-700 text-white shadow-md"
                  : "text-green-900 hover:bg-green-100"
              }`
            }
          >
            {!isCollapsed && (
              <Navigation className="w-5 h-5 mr-3 flex-shrink-0" />
            )}
            {isCollapsed && <Navigation className="w-5 h-5 flex-shrink-0" />}
            {!isCollapsed && (
              <span className="truncate">Explore Influencer</span>
            )}
          </NavLink>

          <NavLink
            to="/brand/influencerlist"
            onClick={handleAnchorClick}
            className={({ isActive }) =>
              `flex items-center w-full px-6 py-2.5 text-sm font-medium rounded-lg transition-all ${
                isActive
                  ? "bg-green-700 text-white shadow-md"
                  : "text-green-900 hover:bg-green-100"
              }`
            }
          >
            {!isCollapsed && <List className="w-5 h-5 mr-3 flex-shrink-0" />}
            {isCollapsed && <List className="w-5 h-5 flex-shrink-0" />}
            {!isCollapsed && <span className="truncate">Influencer List</span>}
          </NavLink>
          <NavLink
            to="/brand/jobCampaigns"
            onClick={handleAnchorClick}
            className={({ isActive }) =>
              `flex items-center w-full px-6 py-2.5 text-sm font-medium rounded-lg transition-all ${
                isActive
                  ? "bg-green-700 text-white shadow-md"
                  : "text-green-900 hover:bg-green-100"
              }`
            }
          >
            {!isCollapsed && (
              <StickyNote className="w-5 h-5 mr-3 flex-shrink-0" />
            )}
            {isCollapsed && <StickyNote className="w-5 h-5 flex-shrink-0" />}
            {!isCollapsed && <span className="truncate">Campaigns</span>}
          </NavLink>
          <NavLink
            to="/brand/offers"
            onClick={handleAnchorClick}
            className={({ isActive }) =>
              `flex items-center w-full px-6 py-2.5 text-sm font-medium rounded-lg transition-all ${
                isActive
                  ? "bg-green-700 text-white shadow-md"
                  : "text-green-900 hover:bg-green-100"
              }`
            }
          >
            {!isCollapsed && (
              <HandCoins className="w-5 h-5 mr-3 flex-shrink-0" />
            )}
            {isCollapsed && <HandCoins className="w-5 h-5 flex-shrink-0" />}
            {!isCollapsed && <span className="truncate">Direct Offers</span>}
          </NavLink>

          {/* <NavLink
            to="/brand/orders"
            onClick={handleAnchorClick}
            className={({ isActive }) =>
              `flex items-center w-full px-6 py-2.5 text-sm font-medium rounded-lg transition-all ${
                isActive
                  ? "bg-green-700 text-white shadow-md"
                  : "text-green-900 hover:bg-green-100"
              }`
            }
          >
            {!isCollapsed && (
              <ShoppingCart className="w-5 h-5 mr-3 flex-shrink-0" />
            )}
            {isCollapsed && <ShoppingCart className="w-5 h-5 flex-shrink-0" />}
            {!isCollapsed && <span className="truncate">Orders</span>}
          </NavLink> */}

          <NavLink
            to="/brand/chat"
            onClick={handleAnchorClick}
            className={({ isActive }) =>
              `flex items-center w-full px-6 py-2.5 text-sm font-medium rounded-lg transition-all ${
                isActive
                  ? "bg-green-700 text-white shadow-md"
                  : "text-green-900 hover:bg-green-100"
              }`
            }
          >
            {!isCollapsed && (
              <MessagesSquare className="w-5 h-5 mr-3 flex-shrink-0" />
            )}
            {isCollapsed && (
              <MessagesSquare className="w-5 h-5 flex-shrink-0" />
            )}
            {!isCollapsed && <span className="truncate">Messages</span>}
          </NavLink>

          <NavLink
            to="/brand/assets"
            onClick={handleAnchorClick}
            className={({ isActive }) =>
              `flex items-center w-full px-6 py-2.5 text-sm font-medium rounded-lg transition-all ${
                isActive
                  ? "bg-green-700 text-white shadow-md"
                  : "text-green-900 hover:bg-green-100"
              }`
            }
          >
            {!isCollapsed && (
              <GalleryVerticalEnd className="w-5 h-5 mr-3 flex-shrink-0" />
            )}
            {isCollapsed && (
              <GalleryVerticalEnd className="w-5 h-5 flex-shrink-0" />
            )}
            {!isCollapsed && <span className="truncate">Assets</span>}
          </NavLink>

          <SectionDivider />

          <NavLink
            to="/brand/reports"
            onClick={handleAnchorClick}
            className={({ isActive }) =>
              `flex items-center w-full px-6 py-2.5 text-sm font-medium rounded-lg transition-all ${
                isActive
                  ? "bg-green-700 text-white shadow-md"
                  : "text-green-900 hover:bg-green-100"
              }`
            }
          >
            {!isCollapsed && (
              <ChartNoAxesCombined className="w-5 h-5 mr-3 flex-shrink-0" />
            )}
            {isCollapsed && (
              <ChartNoAxesCombined className="w-5 h-5 flex-shrink-0" />
            )}
            {!isCollapsed && (
              <span className="truncate">Campaign Analytics</span>
            )}
          </NavLink>

          <SectionDivider />

          <NavLink
            to="/brand/owl"
            onClick={handleAnchorClick}
            className={({ isActive }) =>
              `flex items-center w-full px-6 py-2.5 text-sm font-medium rounded-lg transition-all ${
                isActive
                  ? "bg-green-700 text-white shadow-md"
                  : "text-green-900 hover:bg-green-100"
              }`
            }
          >
            {!isCollapsed && (
              <img
                src={`${process.env.PUBLIC_URL}/images/Owl_image.jpg`}
                alt="Tama AI"
                className="w-5 h-5 mr-3 rounded-full flex-shrink-0 object-cover"
              />
            )}
            {isCollapsed && (
              <img
                src={`${process.env.PUBLIC_URL}/images/Owl_image.jpg`}
                alt="Tama AI"
                className="w-5 h-5 rounded-full flex-shrink-0 object-cover"
              />
            )}
            {!isCollapsed && <span className="truncate">Tama AI Agent</span>}
          </NavLink>

          <NavLink
            to="/brand/recommendations"
            onClick={handleAnchorClick}
            className={({ isActive }) =>
              `flex items-center w-full px-6 py-2.5 text-sm font-medium rounded-lg transition-all ${
                isActive
                  ? "bg-green-700 text-white shadow-md"
                  : "text-green-900 hover:bg-green-100"
              }`
            }
          >
            {!isCollapsed && (
              <ThumbsUp className="w-5 h-5 mr-3 flex-shrink-0" />
            )}
            {isCollapsed && <ThumbsUp className="w-5 h-5 flex-shrink-0" />}
            {!isCollapsed && <span className="truncate">Recommendations</span>}
          </NavLink>

          <NavLink
            to="/brand/briefing"
            onClick={handleAnchorClick}
            className={({ isActive }) =>
              `flex items-center w-full px-6 py-2.5 text-sm font-medium rounded-lg transition-all ${
                isActive
                  ? "bg-green-700 text-white shadow-md"
                  : "text-green-900 hover:bg-green-100"
              }`
            }
          >
            {!isCollapsed && (
              <ScrollText className="w-5 h-5 mr-3 flex-shrink-0" />
            )}
            {isCollapsed && <ScrollText className="w-5 h-5 flex-shrink-0" />}
            {!isCollapsed && <span className="truncate">Brief Generator</span>}
          </NavLink>

          <NavLink
            to="/brand/frauddetectiontools"
            onClick={handleAnchorClick}
            className={({ isActive }) =>
              `flex items-center w-full px-6 py-2.5 text-sm font-medium rounded-lg transition-all ${
                isActive
                  ? "bg-green-700 text-white shadow-md"
                  : "text-green-900 hover:bg-green-100"
              }`
            }
          >
            {!isCollapsed && (
              <ShieldAlert className="w-5 h-5 mr-3 flex-shrink-0" />
            )}
            {isCollapsed && <ShieldAlert className="w-5 h-5 flex-shrink-0" />}
            {!isCollapsed && (
              <span className="truncate">Fake Detection Tool</span>
            )}
          </NavLink>

          <SectionDivider />
          <a
            href="https://calendly.com/darshana-munde/30min?month=2025-08"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleAnchorClick}
            className="flex items-center w-full px-6 py-2.5 text-sm font-medium rounded-lg text-green-900 hover:bg-green-100 transition-all"
          >
            {!isCollapsed && (
              <BookOpenCheck className="w-5 h-5 mr-3 flex-shrink-0" />
            )}
            {isCollapsed && <BookOpenCheck className="w-5 h-5 flex-shrink-0" />}
            {!isCollapsed && <span className="truncate">Book Training</span>}
          </a>

          <SectionDivider />

          <NavLink
            to="/brand/tamacoin"
            onClick={handleAnchorClick}
            className={({ isActive }) =>
              `flex items-center w-full px-6 py-2.5 text-sm font-medium rounded-lg transition-all ${
                isActive
                  ? "bg-green-700 text-white shadow-md"
                  : "text-green-900 hover:bg-green-100"
              }`
            }
          >
            {!isCollapsed && (
              <ScreenShare className="w-5 h-5 mr-3 flex-shrink-0" />
            )}
            {isCollapsed && <ScreenShare className="w-5 h-5 flex-shrink-0" />}
            {!isCollapsed && <span className="truncate">Tama Coins</span>}
          </NavLink>

          <SectionDivider />

          <NavLink
            to="/brand/campaigns"
            onClick={handleAnchorClick}
            className={({ isActive }) =>
              `flex items-center w-full px-6 py-2.5 text-sm font-medium rounded-lg transition-all ${
                isActive
                  ? "bg-green-700 text-white shadow-md"
                  : "text-green-900 hover:bg-green-100"
              }`
            }
          >
            {!isCollapsed && (
              <Megaphone className="w-5 h-5 mr-3 flex-shrink-0" />
            )}
            {isCollapsed && <Megaphone className="w-5 h-5 flex-shrink-0" />}
            {!isCollapsed && <span className="truncate">Smart Campaigns</span>}
          </NavLink>
        </nav>
      </SidebarContent>

      <SidebarFooter
        className={`${
          isCollapsed ? "px-2" : "px-4"
        } py-4 border-t border-green-200 bg-green-50`}
      >
        {!isCollapsed && (
          <div className="space-y-3">
            <div className="flex justify-center flex-wrap gap-x-4 gap-y-1 text-xs">
              <a
                href="https://tamayou.com/tama-privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-green-800 hover:text-green-600 transition-colors hover:underline"
              >
                Privacy
              </a>
              <a
                href="https://tamayou.com/terms/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-green-800 hover:text-green-600 transition-colors hover:underline"
              >
                Terms
              </a>
              <a
                href="https://tamayou.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-green-800 hover:text-green-600 transition-colors hover:underline flex items-center gap-1"
              >
                Corp Site
                <Link className="w-3 h-3" />
              </a>
            </div>
            <div className="text-xs text-center text-green-800">
              © {new Date().getFullYear()} TAMA
            </div>
          </div>
        )}
        {isCollapsed && (
          <div className="text-xs text-center text-green-800">
            © {new Date().getFullYear()}
          </div>
        )}
      </SidebarFooter>
    </Sidebar>
  );
};
